import { useTranslation } from 'react-i18next';

export default function BrandStory() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="mb-2">
          <span className="text-xs text-foreground-500 font-medium tracking-wider uppercase">
            {t('品牌故事')}
          </span>
        </div>

        <div className="max-w-2xl">
          <h1 className="font-heading text-2xl md:text-4xl text-foreground-900 leading-tight mb-6">
            {t('专为移动端设计的免费动漫平台')}
          </h1>

          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
            <p>{t('品牌介绍内容1')}</p>
            <p>{t('品牌介绍内容2')}</p>
            <p>{t('品牌介绍内容3')}</p>
            <p>{t('品牌介绍内容4')}</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-6 mb-10">
          <div className="w-full md:w-[40%]">
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20modern%20creative%20office%20space%20with%20natural%20light%2C%20anime%20posters%20on%20walls%2C%20wooden%20desks%20with%20computers%2C%20cherry%20blossom%20decorations%2C%20cozy%20atmosphere%2C%20clean%20minimalist%20design%2C%20warm%20coral%20and%20cream%20tones%2C%20professional%20photography&width=800&height=600&seq=about-team-office&orientation=landscape"
                alt="樱花动漫团队办公环境"
                title="樱花动漫团队办公环境"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="w-full md:w-[60%]">
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20held%20in%20hand%20displaying%20colorful%20anime%20streaming%20interface%2C%20cherry%20blossom%20petals%20floating%20around%2C%20warm%20golden%20sunset%20lighting%2C%20cozy%20home%20setting%2C%20clean%20composition%2C%20lifestyle%20photography%2C%20warm%20coral%20and%20cream%20tones&width=1200&height=600&seq=about-mobile-app&orientation=landscape"
                alt="樱花动漫移动端界面"
                title="樱花动漫-移动端体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="bg-background-100 rounded-xl p-6 md:p-8 max-w-2xl">
          <h3 className="font-heading text-lg text-foreground-900 mb-3">{t('品牌愿景')}</h3>
          <p className="text-sm text-foreground-600 leading-relaxed">{t('品牌愿景内容')}</p>
        </div>
      </div>
    </section>
  );
}